module.exports = __webpack_public_path__ + "img/scaleData.de2f5d5b.png";